export default "__VITE_ASSET__BR2_HfKD__"